import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/bankCut/payment/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/bankCut/payment/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/bankCut/payment/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/bankCut/payment/save', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/bankCut/payment/update', params, options);

export const getAmountAndCutNum = (params, options) =>
  request.get(
    '/api/v4ward/bankCut/payment/getAmountAndCutNum',
    Object.assign({}, options, { params })
  );

export const checkBill = (formData) => {
  return request({
    url: '/api/v4ward/bankCut/payment/checkAndCount',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const submitUploadBill = (formData) => {
  return request({
    url: '/api/v4ward/bankCut/payment/uploadAnUpdate',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const getBankCutPaymentTree = (params, options) =>
  request.get('/api/v4ward/bankCut/payment/tree', Object.assign({}, options, { params }));
